<lib-dlg titulo="Exclusão de requisição {{rcmsExcluido?.numero}}" nome="dlgExclusaoRcms" [visualizar]="visualizar" (onHide)="onHide()"
styleClassHeader="text-white bg-danger">
  <p class="small"><i>Opção só permitida para requisição sem vinculo com compra.</i></p>
  <div class="row">
    <div class="col-md-12">
      <label for="motivo_exclusao">
        Informe a justificativa para o exclução da requisição
        <span class="text-danger">*</span>
      </label>
      <textarea [(ngModel)]="rcmsExcluido.motivo_exclusao" class="form-control" id="motivo_exclusao" rows="3"></textarea>
    </div>
  </div>
  <ng-container opcoes>
    <button (click)="estornar()" type="submit" class="btn btn-danger btn-sm float-right ml-2">Confirmar</button>
  </ng-container>
</lib-dlg>